// User-facing copy for the jersey retention setting.

import { defineMessages } from 'react-intl';

import { SportTermLookup, SportTerminology } from '../../lib/types';

export const scope = 'app.components.JerseyAssignment';

export const getMessages = (termLookup: SportTermLookup) => {
  const athleteTerm = termLookup[SportTerminology.ATHLETE].toLowerCase();
  const sessionTerm = termLookup[SportTerminology.SESSION].toLowerCase();
  return defineMessages({
    lblRetainJerseyAssignments: {
      id: `${scope}.lblRetainJerseyAssignments`,
      defaultMessage: `Keep jerseys and numbers from one ${sessionTerm} to the next`,
    },
    captionRetainAssociation: {
      id: `${scope}.captionRetainAssociation`,
      defaultMessage: `When on, check-in pre-fills each ${athleteTerm}'s jersey and number from their last ${sessionTerm}. When off, every ${sessionTerm} starts blank. Applies right away to every assessment that hasn't chosen its own setting.`,
    },
    titleAgeGroups: {
      id: `${scope}.titleAgeGroups`,
      defaultMessage: 'Jerseys by age group',
    },
    captionAgeGroups: {
      id: `${scope}.captionAgeGroups`,
      defaultMessage: `Each age group follows the assessment unless you choose otherwise. Every ${athleteTerm} follows their age group.`,
    },
    lblAgeGroupRetention: {
      id: `${scope}.lblAgeGroupRetention`,
      defaultMessage: 'Jerseys and numbers',
    },
    optFollowAssessment: {
      id: `${scope}.optFollowAssessment`,
      defaultMessage: 'Follow the assessment ({current})',
    },
    currentKept: {
      id: `${scope}.currentKept`,
      defaultMessage: 'kept',
    },
    currentReset: {
      id: `${scope}.currentReset`,
      defaultMessage: 'reset',
    },
    optKeep: {
      id: `${scope}.optKeep`,
      defaultMessage: `Keep from one ${sessionTerm} to the next`,
    },
    optReset: {
      id: `${scope}.optReset`,
      defaultMessage: `Start each ${sessionTerm} blank`,
    },
    errAgeGroupSave: {
      id: `${scope}.errAgeGroupSave`,
      defaultMessage: "Couldn't save the jersey setting for {name}. Please try again.",
    },
    loadingAgeGroups: {
      id: `${scope}.loadingAgeGroups`,
      defaultMessage: 'Loading age groups…',
    },
    errAgeGroupsLoad: {
      id: `${scope}.errAgeGroupsLoad`,
      defaultMessage: "Couldn't load the age groups. Please refresh the page.",
    },
    noAgeGroups: {
      id: `${scope}.noAgeGroups`,
      defaultMessage: 'This assessment has no age groups yet.',
    },
    captionRetainAssessment: {
      id: `${scope}.captionRetainAssessment`,
      defaultMessage: `When on, check-in pre-fills each ${athleteTerm}'s jersey and number from their last ${sessionTerm} in this assessment. While left unset (—), the association-level setting applies instead.`,
    },
  });
};
